module.exports = __webpack_public_path__ + "img/tips-for-households.5d41312.webp";